import { lazy } from 'react';

export const LazyTripleBarColorPicker = lazy(() => import('./TripleBarColorPicker'));

export const LazyCodeEditor = lazy(() => import('./CodeEditor'));

export const LazyColorizedPreformattedText = lazy(() => import('./ColorizedPreformattedText'));
